"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCompanyDto = exports.UpdateCompanyDocMapDto = exports.UpdateGroupCompanyMapDto = exports.UpdateGstDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
const update_address_dto_1 = require("../../address/dto/update-address.dto");
class UpdateGstDto {
}
exports.UpdateGstDto = UpdateGstDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "GST ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateGstDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "State ID", example: 1 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "State ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateGstDto.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "GST number",
        example: "22ABCDE1234F1Z5",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "GST number must be a string." }),
    (0, class_validator_1.Matches)(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, {
        message: "Invalid GST number format. It should follow the format: 22ABCDE1234F1Z5.",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateGstDto.prototype, "gstNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "GST category ID", example: 101 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "GST category ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateGstDto.prototype, "gstCategoryLid", void 0);
class UpdateGroupCompanyMapDto {
}
exports.UpdateGroupCompanyMapDto = UpdateGroupCompanyMapDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Group Company Map ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateGroupCompanyMapDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Company ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateGroupCompanyMapDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Group Company ID",
        example: 2,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Group Company ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateGroupCompanyMapDto.prototype, "groupCompanyId", void 0);
class UpdateCompanyDocMapDto {
}
exports.UpdateCompanyDocMapDto = UpdateCompanyDocMapDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Company Document Map ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDocMapDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Company ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDocMapDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Document ID",
        example: 101,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Document ID must be a valid number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDocMapDto.prototype, "documentId", void 0);
class UpdateCompanyDto {
}
exports.UpdateCompanyDto = UpdateCompanyDto;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display name of the company",
        example: "Tech Solutions",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Display name must be a string." }),
    (0, class_validator_1.MinLength)(3, { message: "Display name must be at least 3 characters long." }),
    (0, class_validator_1.MaxLength)(100, { message: "Display name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Company type ID", example: 1 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Company type id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Currency id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "currencyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Industry segment ID", example: 191 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Industry segment id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "industrySegmentLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Group company lid", example: 48 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Group company id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "groupCompanyLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "existingBrokerName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "insurerName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "tpaName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of employees",
        example: 500,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Number of employees must be a valid number." }),
    (0, class_validator_1.Min)(0, { message: "Number of employees must be a positive number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "noOfEmployees", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Date of incorporation",
        example: "2020-01-15",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Date of incorporation must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Date of incorporation must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const date = new Date(value);
        if (date > new Date()) {
            throw new common_1.BadRequestException("Date of incorporation cannot be a future date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "dateOfIncorporation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "PAN card number",
        example: "ABCDE1234F",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "PAN card number must be a string." }),
    (0, class_validator_1.Matches)(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, {
        message: "Invalid PAN format. It should be in the format ABCDE1234F.",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "panCardNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Registration number",
        example: "L98765DL1999PLC987654",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Registration number must be a string." }),
    (0, class_validator_1.Matches)(/^[UL]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/, {
        message: "Invalid registration number. It should be in the format L98765DL1999PLC987654.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "registrationNo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Annual premium", example: 1000000 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Annual premium must be a valid number." }),
    (0, class_validator_1.Min)(0, { message: "Annual premium must be a positive number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "annualPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "TAN number",
        example: "ABCD12345E",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "TAN number must be a string." }),
    (0, class_validator_1.Matches)(/^[A-Z]{4}[0-9]{5}[A-Z]{1}$/, {
        message: "Invalid TAN format. It should be in the format ABCD12345E.",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "tanNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Website URL",
        example: "https://www.techsolutions.com",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Website must be a string." }),
    (0, class_validator_1.IsUrl)({}, { message: "Website must be a valid URL." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "website", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Remarks",
        example: "Strong potential for growth in the next 5 years.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 500) {
            throw new common_1.BadRequestException("Company remarks must not exceed 500 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Source Type", example: 2 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Source type must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "sourceTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Source", example: "Internal" }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Source must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Source must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateCompanyDto.prototype, "source", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Priority ID", example: 1 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Priority ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "priorityLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Status ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "LeadCRM", example: 2 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "LeadCRM must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "leadCrm", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Account Manager", example: 4 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Account manager must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "accountManager", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Country id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Sentiment ID",
        type: Number,
        example: 1,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Sentiment id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "sentimentLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "GST details",
        type: [UpdateGstDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdateGstDto),
    tslib_1.__metadata("design:type", Array)
], UpdateCompanyDto.prototype, "gstDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Group Company Maps",
        type: UpdateGroupCompanyMapDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdateGroupCompanyMapDto),
    tslib_1.__metadata("design:type", UpdateGroupCompanyMapDto)
], UpdateCompanyDto.prototype, "groupCompanyMap", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Company Document Maps",
        type: [UpdateCompanyDocMapDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdateCompanyDocMapDto),
    tslib_1.__metadata("design:type", Array)
], UpdateCompanyDto.prototype, "companyDocMaps", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateCompanyDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Company Address",
        type: [update_address_dto_1.UpdateAddressDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Company address must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => update_address_dto_1.UpdateAddressDto),
    tslib_1.__metadata("design:type", Array)
], UpdateCompanyDto.prototype, "addresses", void 0);
